import { HRResourcesContentCreate } from "./hrResourcesContentCreate";
import { HRResourcesContentEdit } from "./hrResourcesContentEdit";
import { HRResourcesContentList } from "./hrResourcesContentList";

export default {
	create: HRResourcesContentCreate,
	edit: HRResourcesContentEdit,
	list: HRResourcesContentList,
};
